import { flatten, map } from 'lodash';

export interface ICompleteIhmsData {
  actionItemId?: string;
  documentInfo?: IDocumentInfoData[];
}

export interface IDocumentInfoData {
  lfEntryID?: number;
  documentFileName?: string;
  documentDescription?: string;
}

export class CompleteIhms {
  actionItemId?: string;
  documentInfo: DocumentInfo[];

  constructor(data: Partial<ICompleteIhmsData>) {
    this.actionItemId = data?.actionItemId;
    const flattenedDocs: IDocumentInfoData[] = flatten(data?.documentInfo || []);
    this.documentInfo = map(
      flattenedDocs,
      (doc: IDocumentInfoData) => new DocumentInfo(doc)
    );
  }
}

export class DocumentInfo {
  lF_id?: string;
  document_name?: string;
  document_description?: string;
  document_id?: string;

  constructor(data: Partial<IDocumentInfoData>) {
    this.lF_id = data?.lfEntryID.toString();
    this.document_name = data?.documentFileName;
    this.document_description = data?.documentDescription;
    this.document_id = data?.lfEntryID?.toString();
  }
}
